/* eslint-disable @typescript-eslint/no-explicit-any */
import {ApplyJobInternal} from '@jobseeker/feature-job/components/UserJobApplication';
import {Box, Typography} from '@mui/material';

export const ReviewView = ({containerStyles}: any) => {
  const onChange = () => {};
  return (
    <Box className="review" width={'100%'} mt={3}>
      <Typography mb={2} fontSize={18} fontWeight={500} component={'p'}>
        Review your Application{' '}
      </Typography>
      <ApplyJobInternal
        containerProps={{p: 0}}
        refInfo={''}
        onChange={onChange}
      />
    </Box>
  );
};
export default ReviewView;
